export default __webpack_public_path__ + "static/media/kongo.9f34e1be.svg";